import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Menu from "./pages/Menu";
import Getraenke from "./pages/Getraenke";
import Mitnahmekarte from "./pages/Mitnahmekarte";
import Contact from "./pages/Contact";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Admin from "./pages/Admin";
import CookieBanner from "./components/CookieBanner";
import VacationBanner from "./components/VacationBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="paper-texture" aria-hidden="true" />
        <Routes>
          {/* Admin ohne Navbar/Footer */}
          <Route path="/admin" element={<Admin />} />
          {/* Öffentliche Seiten */}
          <Route
            path="*"
            element={
              <>
                <Navbar />
                <main>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/menu" element={<Menu />} />
                    <Route path="/getraenke" element={<Getraenke />} />
                    <Route path="/mitnahmekarte" element={<Mitnahmekarte />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/impressum" element={<Impressum />} />
                    <Route path="/datenschutz" element={<Datenschutz />} />
                  </Routes>
                </main>
                <Footer />
                <CookieBanner />
                <VacationBanner />
              </>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
